import React, { useState, useEffect, useRef } from "react";
import ApiClient from "../services/api-client"
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'

import IFramePrintTemplate from '../components/iframe-print-template.component';
import InvoiceSimpleView from '../components/sales/invoice-simple-view.component';
import usePrintSaleBuilder from "../hooks/usePrintSaleBuilder";
import Logo from '../img/timologic.png';
import Slider from 'rc-slider';


export default function InvoiceView() {

    const [sentjson, setSentJson] = useState({});
    const { t } = useTranslation();
    const { invoiceUid } = useParams();
    const iframePrintTemplate = useRef();
    const { buildPrintSale } = usePrintSaleBuilder();
    const [sheight, setSheight] = useState(window.innerHeight - 100);
    const [template, setTemplate] = useState(false);
    const [zoomValue, setZoomValue] = useState(100);

    const onClickPrint = () => {
        setTimeout(function () {
            iframePrintTemplate.current.printFrame()
        })
    }

    useEffect(() => {
        ApiClient.getInvoiceViewByInvoiceUid(invoiceUid).then(
            response => {
                if (response != undefined) {
                    if (response.data != "") {
                        var _company = response.data.saleInstance.company;
                        var _branchId = response.data.saleInstance.branchId;
                        const saleInstance = response.data.saleInstance;
                        const config = {
                            nameFromNode: node => node.product.name,
                            muFromNode: (node, t) => t(node.measurementUnit),
                            whTaxFromNode: node => node.myDataWithHoldTaxes?.amountValue ?? "0.00",
                            vatFromNode: node => node.vat.value,
                            idFromNode: node => node.id,
                            codeFromNode: node => node.productCode,
                            logo: saleInstance.logo,
                            issuerAddress: saleInstance.branchAddress,
                            issuerEmail: saleInstance.issuerEmail,
                            issuerPhone: saleInstance.issuerPhone,
                            subjectField: saleInstance.issuerSubjectField,
                            cancelmark: saleInstance.cancellationMark,
                            mark: saleInstance.mark,
                            issuerName: saleInstance.company?.name,
                            senderName: saleInstance.senderName,
                            senderTaxpayerId: saleInstance.senderTaxPayerId,
                            recipientName: saleInstance.recipientName,
                            recipientTaxpayerId: saleInstance.recipientTaxPayerId,
                            customerName: saleInstance.customerName,
                            customerCode: saleInstance.customerCode,
                        };
                        ApiClient.getOpenPageTemplateSettings(_company.id, _branchId).then(templateResponse => {
                            setTemplate(templateResponse.data);
                            const psale = buildPrintSale(saleInstance, config);
                            if (templateResponse.data) {
                                psale.IBAN = templateResponse.data.iban;
                                psale.MOREINFO = templateResponse.data.moreInfo;
                            }
                            iframePrintTemplate.current.setPrintSale(psale);
                        },
                            error => {
                                console.error(
                                    (error.response &&
                                        error.response.data &&
                                        error.response.data.message) ||
                                    error.message ||
                                    error.toString())
                            }
                        );

                        var json = JSON.parse(response.data.body);
                        var instance = response.data.saleInstance;
                        if (json.invoice) {
                            json.invoice[0].cancelledByMark = instance.cancellationMark;
                        }
                        setSentJson(json);
                    } else {
                        document.getElementById("mainViewContainer").style.display = 'none';
                        document.getElementById("notExistMess").style.display = 'block';
                    }
                }
            },
            error => {
                console.error(error.data)
            }
        )
    }, []);

    const hangleZoomChange = (val) => {
        setZoomValue(val);
        var el = document.getElementById('iv-frame-container');
        var h = (el.scrollHeight - el.clientHeight) / 2;
        var w = (el.scrollWidth - el.clientWidth) / 2;
        el.scrollTop = h;
        el.scrollLeft = w;
    }

    window.addEventListener('resize', function () {
        setTimeout(function () {
            setSheight(window.innerHeight - 100);
        }, 300);
    });

    return (
        <div className="iv-page" id="mainViewContainer">

            {/* ── NAVBAR ── */}
            <nav className="iv-nav">
                <div className="iv-nav-brand">
                    <a href="/"><img src={Logo} alt="logo" className="iv-nav-logo" /></a>
                </div>

                <div className="iv-nav-tabs" id="nav-tab" role="tablist">
                    <button
                        className="iv-tab-btn active"
                        id="nav-home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-home"
                        type="button"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                    >
                        <i className="fa fa-eye"></i>
                        <span>{t("Preview")}</span>
                    </button>
                    <button
                        className="iv-tab-btn"
                        id="details-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-details"
                        type="button"
                        role="tab"
                        aria-controls="nav-details"
                        aria-selected="false"
                    >
                        <i className="fa fa-info-circle"></i>
                        <span>{t("Details")}</span>
                    </button>
                    <button
                        className="iv-tab-btn"
                        id="nav-profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-profile"
                        type="button"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                    >
                        <i className="fa fa-code"></i>
                        <span>JSON</span>
                    </button>
                </div>

                <div className="iv-nav-actions">
                    <button onClick={onClickPrint} className="iv-print-btn">
                        <i className="fa fa-print"></i>
                        <span>{t("Print")}</span>
                    </button>
                </div>
            </nav>

            {/* ── TAB CONTENT ── */}
            <div className="tab-content" id="nav-tabContent">

                {/* Preview */}
                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div className="iv-zoom-bar">
                        <i className="fa fa-search-minus iv-zoom-icon"></i>
                        <div className="iv-zoom-slider-wrap">
                            <Slider
                                min={40}
                                max={100}
                                value={zoomValue}
                                onChange={hangleZoomChange}
                                onAfterChange={hangleZoomChange}
                            />
                        </div>
                        <i className="fa fa-search-plus iv-zoom-icon"></i>
                        <span className="iv-zoom-pct">{zoomValue}%</span>
                    </div>
                    <div className="iv-frame-container" id="iv-frame-container" style={{ height: sheight }}>
                        <IFramePrintTemplate
                            style={{ height: '297mm', width: '800px', transform: 'scale(' + (zoomValue / 100) + ')' }}
                            extracss={template.css}
                            template={template}
                            ref={iframePrintTemplate}
                        />
                    </div>
                </div>

                {/* Details */}
                <div className="tab-pane fade" id="nav-details" role="tabpanel" aria-labelledby="details-tab">
                    <InvoiceSimpleView invoice={sentjson?.invoice?.[0]} />
                </div>

                {/* JSON */}
                <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div className="iv-json-container" style={{ height: sheight }}>
                        <JsonView theme="monokai" src={sentjson} />
                    </div>
                </div>

            </div>

            {/* ── NOT FOUND ── */}
            <div className="iv-not-found" id="notExistMess" style={{ display: 'none' }}>
                <i className="fa fa-exclamation-circle iv-not-found-icon"></i>
                <div className="iv-not-found-msg">
                    {t("noInvoiceFound")} <code>{invoiceUid}</code>
                </div>
            </div>

        </div>
    );
}
